import styled from "styled-components";
import {flexAdaptiveSizeItem} from "../../../../../themes/architecture/css-helpers/flex";
import {ButtonLabelOverflow, ButtonSizeVariant} from "../../button-props.interface";

interface IButtonLabelPaddingBoxProps {
    lateralPadding: number;
    sizeVariant: ButtonSizeVariant;
    labelOverflow: ButtonLabelOverflow;
}

export const ButtonLabelPaddingDefaultBox = styled.span<IButtonLabelPaddingBoxProps>`
    ${flexAdaptiveSizeItem}
    
    padding: 0em ${({lateralPadding}) => lateralPadding}em 0em;

    white-space: ${({labelOverflow}) => labelOverflow === "wrap" ? "unset" : "nowrap"}; // use "unset" if you want to allow label wrap, use "nowrap" for expanding the button or ellipsis
    overflow: hidden;
    text-overflow: ${({labelOverflow}) => labelOverflow === "ellipsis" ? "ellipsis" : "clip"};
`;